import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import "./index.css";
import { finishJourney, removeAllDMCData } from "../../ducks/redux/actions/FinancialReferral";
import { userTypedRepairReasons } from "../../ducks/redux/actions/dashboardReducer.actions";
import {
	getHeatingHotWaterCase,
	getMaintResp,
	getRepairResp,
  getContractorName,
  getDeterminedContractorDetails,
  getContractorPayload,
} from "../../ducks/redux/actions/getAddress";
import { WorksOrderRequest } from "../../models/WorksOrders/WorksOrderRequest";
import appointmentImg from "../../assets/icons/Appointment-Icon.png";
import EmailImg from "../../assets/icons/email-icon.png";
import SMSImg from "../../assets/icons/sms-icon.png";

import {
  userChosenPropertyId,
  userChosenPropertyType,
  userChosenPropertyAddress,
  userChosenRepairLocationId,
  userChosenRepairLocation,
  userChosenHighLevelDescription,
  userChosenSupplementaryQuestions,
  userChosenDuplicateQuestion,
  userChosenAdditionalDescription,
  userChosenVandalismQuestion,
  userChosenVandalismAdditionalInformation,
  userChosenCovidQuestion,
  userChosenVulnerabilityQuestion,
  userChosenVulnerabilityAdditionalInformation,
  userChosenContactDetails,
  userChosenUPRN,
  userChosenSOR,
  userChosenSTATUS,
  userChosenEligibilityErrorCode,
  userChosenContactPhone,
  userChosenContactName,
  userChosenRelationDetails,
  backToRepairAsset,
  loadDuplicateRepairPage,
  userChosenResumeRepair,
  workOrderData,
} from "../../ducks/redux/actions/userChoices";
import { isMobile } from "react-device-detect";

const AppointmentError: React.FC<any> = (props) => {
  const pageName = props.location?.state?.pageName
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isError = useSelector(
    (state: any) => state?.userChoicesReducer?.userIsError
  );
    const workOrderObject = useSelector(
      (state: any) => state?.addresses?.workOrderRepair
    );
  let iconSrc:string = "";  
  let TitleMsg:string = "";
  let msgError: string = "";
  let btnTitle: string = "";

    if(pageName === "Email") {
      iconSrc = EmailImg;
      TitleMsg = t("Block_Email_Failure_Header");
      msgError = t("Block_API_Failure");
      btnTitle = t("refresh");
     
    }else if(pageName === "SMS") {
      iconSrc = SMSImg;
      TitleMsg = t("Block_Sms_Failure_Header");
      msgError = t("Block_API_Failure");
      btnTitle = t("refresh");
    }else if(pageName === "AppointmentError"){
      iconSrc = appointmentImg;
      TitleMsg = t("Appointment_Failure");
      msgError = t("Appointment_Failure_Finish_Repair");
      btnTitle = t("finish_button");
    }
  
  const callPageHandler = () => {
     if(pageName === "Email" || pageName === "SMS") {
      props.history.push('/Asset360View');   
     }else {
       // Removing dmc data if it stored in redux
       dispatch(removeAllDMCData(null));
      dispatch(finishJourney(true));
      dispatch(userChosenPropertyId(""));
      dispatch(userChosenPropertyType(""));
      dispatch(userChosenPropertyAddress(""));
      dispatch(userTypedRepairReasons(""));
      dispatch(userChosenRepairLocationId(0));
      dispatch(userChosenRepairLocation(""));
      dispatch(userChosenHighLevelDescription(""));
      dispatch(userChosenSupplementaryQuestions(""));
      dispatch(userChosenDuplicateQuestion(""));
      dispatch(userChosenAdditionalDescription(""));
      dispatch(userChosenVandalismQuestion("No"));
      dispatch(userChosenVandalismAdditionalInformation(""));
      dispatch(userChosenCovidQuestion(""));
      dispatch(userChosenVulnerabilityQuestion(""));
      dispatch(userChosenVulnerabilityAdditionalInformation(""));
      dispatch(userChosenContactDetails(""));
      dispatch(userChosenUPRN(""));
      dispatch(userChosenSOR(""));
      dispatch(getRepairResp(""));
      dispatch(getHeatingHotWaterCase(""));
      dispatch(getMaintResp(""));
      dispatch(getDeterminedContractorDetails(""));
      dispatch(getContractorName(""));
      dispatch(getContractorPayload(""));
      dispatch(userChosenSTATUS(""));
      dispatch(userChosenEligibilityErrorCode(""));
      dispatch(userChosenContactPhone(""));
      dispatch(userChosenContactName(""));
      dispatch(userChosenRelationDetails(""));
      dispatch(backToRepairAsset(false))
      dispatch(userChosenResumeRepair(false));
      dispatch(loadDuplicateRepairPage(false));
      const worksOrder = new WorksOrderRequest(workOrderObject);
      dispatch(workOrderData(worksOrder))
      props.history.push(`/WorkOrder360View/${worksOrder.identifiers?.worksOrderIdentifier}`);
     }
    };

  return (
    <div className="fullscreenDiv mt-4 mt-perc sm:px-2 ctn-fht">
            {isError ? (
              <div className="w-full text-left my-2 font-AvantGardeGothic-Md">
                {t("IDEM_Error")}
              </div>
            ) : 
            (<>
              <img src={iconSrc} className=" text-2xl bd-highlight logo logoLeft" alt="error-icon"/>
              <h1 className="error-none">error-message</h1>
              <strong className="genericError mt-2">{TitleMsg}</strong>
              <span className={isMobile?"genericError ml-2":"genericErrorDesktop ml-2"}>{msgError}</span>
              </>)
          }
         
      <div className="mt-2">
          <button
            id="btn_finish_noAppoint"
            data-testid="finshrepair"
            onClick={callPageHandler}
            className="button-class sm:mt-4 flex items-center"
          >
            {(pageName !== "AppointmentError") && (
             <svg className="ml-2 mr-2" width="19" height="19" viewBox="0 0 19 19" fill="none" aria-hidden="true" style={{ transform: "scaleX(-1)" }}>
            <path d="M8 3V1L4 4.5L8 8V6C10.21 6 12 7.79 12 10C12 12.21 10.21 14 8 14C5.79 14 4 12.21 4 10H2C2 13.31 4.69 16 8 16C11.31 16 14 13.31 14 10C14 6.69 11.31 4 8 4V3Z" fill="currentColor"/>
            </svg>
            )}
            {btnTitle}
          </button>
       
       </div>
    </div>

  )

}
export default AppointmentError;